// 嗅探transform可支持的前缀
var _elementStyle = document.createElement('div').style;
var _vendor = (function () {
  var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'];
  var transform;
  var i = 0;
  var l = vendors.length;
  for (; i < l; i++) {
    transform = vendors[i] + 'ransform';
    if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
  }

  return false;
})();
var _prefixStyle = function (style) {
  if (_vendor === false) return false;
  if (_vendor === '') return style;
  return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

var transition = {
  prefixStyle: _prefixStyle,
  transform: _prefixStyle('transform'),
  transformProperty: _prefixStyle('transitionProperty'),
  transitionDuration: _prefixStyle('transitionDuration'),
  transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
  // 设置transition属性
  setProperty: function (obj, property) {
    obj.style[_prefixStyle('transitionProperty')] = property;
  },
  // 页面滑动到指定位置
  setTransform: function (obj, x, y) {
    obj.style[_prefixStyle('transform')] = 'translate3d(' + x + 'px,' + y + 'px, 0px)';
  },
  // 设置transition间隔时间
  setDuration: function (obj, time) {
    obj.style[_prefixStyle('transitionDuration')] = time + 'ms';
  },
  // 设置scale
  setScale: function (obj, scale) {
    obj.style[_prefixStyle('transform')] = 'scale(' + scale + ')';
  },
  // 设置transition的动画贝塞尔曲线
  setTimingFunction: function (obj, easing) {
    obj.style[_prefixStyle('transitionTimingFunction')] = easing;
  }
}
export default transition;



// WEBPACK FOOTER //
// ./packages/utils/transition.js